import PropTypes from 'prop-types';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';

const MapType = (props) => {
    const { disabled } = props;
    return (
        <MenuItem
            data-testid={props['data-testid']}
            sx={{ height: '25px', paddingLeft: '1px', fontSize: '12px', opacity: disabled ? 0.5 : 1 }}
            onClick={disabled ? undefined : props.onClick}
            disabled={disabled}
        >
            <Checkbox
                color="default"
                checked={props.checked}
                disabled={disabled}
                inputProps={{ 'aria-label': 'controlled' }}
            />
            { props.children }
        </MenuItem>
    );
};

MapType.propTypes = {
    onClick: PropTypes.func,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
};

export default MapType;
